import { Button, Card, CardActions, CardContent, CardHeader, makeStyles, Avatar, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core"
import { AccountCircle, PhoneIphone, ContactPhone, CalendarToday, Edit } from '@material-ui/icons';
import { renderDate } from "common/services/util";
import React from "react"

const CardTaskSign = ({ data, showSign1, showSign2 }) => {
    const classes = useStyles();

    const item = (text, subText, icon) => {
        return (
            <ListItem style={{ minHeight: '100px' }}>
                <ListItemAvatar>
                    <Avatar>
                        { icon }
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={text} secondary={subText} />
            </ListItem>
        )
    }

    return (
        <Card className={classes.main}>
            <CardHeader
                title={`Reparacion: ${data.reference}`}
            />
            <CardContent className={classes.content}>
                <List className={classes.column}>
                    { item(data.clientName, data.dni, <AccountCircle />) }
                    { item("Teléfono", data.phone, <ContactPhone />) }
                </List>
                <List className={classes.column}>
                    { item(data.deviceName, data.description, <PhoneIphone />) }
                    { item("Fecha entrada", renderDate(data.dateEntry), <CalendarToday />) }
                </List>
            </CardContent>
            <CardActions>
                <Button
                    className={classes.actionSign}
                    variant="contained"
                    color="primary"
                    style={{ backgroundColor: data.docSign ? '#4caf50' : '' }}
                    onClick={showSign1}
                >
                    { data.docSign && <Edit style={{ position: 'absolute', left: '20px' }} /> } FIRMA ENTRADA
                </Button>
                { data.docSign && <Button
                    className={classes.actionSign}
                    variant="contained"
                    color="primary"
                    onClick={showSign2}
                >
                    FIRMA SALIDA
                </Button> }
            </CardActions>
        </Card>
    )
}

const useStyles = makeStyles(theme => ({
    main: {
        width: '500px',
        display: 'flex',
        flexDirection: 'column'
    },
    content: {
        display: 'flex',
        flex: 1
    },
    column: {
        width: '100%'
    },
    action: {
        width: '100%'
    },
    actionSign: {
        height: '50px',
        width: '100%'
    }
}))

export default CardTaskSign